import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import makeInitialState from './initialState';

export default {
  namespaced: true,
  state: makeInitialState(),
  actions,
  mutations,
  getters,
  // potential getters for future features
  // getters: {
  //   pastEvents,
  //   futureEvents,
  // }
  hagridOn: {
    logout: 'clear',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/recordings/index.js